export const IDS_API_ENDPOINT = "https://script.google.com/macros/s/AKfycbxTCeol8z1TfkwcYEkXURKGXAPyUHteb9bB_HUoD-bgUkXPvfy3d0WPAK8vuLoFJuwi/exec";
export const CONFIRMATION_API_ENDPOINT = "https://script.google.com/macros/s/AKfycbzbQORbCPj_h2JCFCOK-jA7tDrRzzrAivNsDNf1DAkzZnsHfxMV-Y8FEur9HECT6FvI_w/exec";

export function warmUpGuestService() {
  const params = new URLSearchParams({
    id: "XXXX",
    warmup: Date.now().toString(),
  });

  return fetch(`${IDS_API_ENDPOINT}?${params.toString()}`, {
    method: "GET",
    cache: "no-store",
  });
}
